import React from "react";
import PropTypes from "prop-types";
import { useCubeQuery } from "@cubejs-client/react";
import { Spin, Row, Col, Statistic, Table } from "antd";
import {
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  BarChart,
  Bar,
  LineChart,
  Line,
} from "recharts";

import moment from "moment";

const dateFormatter = item => moment(item).format("MMM 'YY");
const dateDayFormatter = item => moment(item).format("MMM DD 'YY");
const dateTimeFormatter = item => moment(item).format("MMM DD 'YY hh:mm:ss a");
// const dateTimeFormat = "MMM 'YY";
// const dateFormatter = item => moment(item).format(dateTimeFormat);


const convertToFormalHours = function (totalSeconds) {
  let negative;
  // Find a Negative number
  if (totalSeconds < 0) { negative = true } else { negative = false }
  if (negative) { totalSeconds = totalSeconds * -1; }
  var hours = Math.floor(totalSeconds / 3600);
  var minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
  var seconds = totalSeconds - (hours * 3600) - (minutes * 60);
  // round seconds
  seconds = Math.round(seconds * 100) / 100
  var result = (hours < 10 ? "0" + hours : hours);
  result += ":" + (minutes < 10 ? "0" + minutes : minutes);
  result += ":" + (seconds < 10 ? "0" + seconds : seconds);
  if (negative) { return result = '-' + result } else { return result };
}

const CartesianChart = ({ resultSet, children, ChartComponent }) => (
  <ResponsiveContainer width="100%" height={350}>
    <ChartComponent data={resultSet.chartPivot()} cursor="pointer">
      {/* <XAxis dataKey="x" /> */}

      {console.log('resultSet =', resultSet.loadResponse.query.timeDimensions[0].granularity)}



      {(() => {
        if (resultSet.loadResponse.query.timeDimensions[0].granularity === 'hour') {
          return (
            <XAxis dataKey="x" tickFormatter={dateTimeFormatter} />
          )
        } else if (resultSet.loadResponse.query.timeDimensions[0].granularity === 'day') {
          return (
            <XAxis dataKey="x" tickFormatter={dateDayFormatter} />
          )
        } else {
          return (
            <XAxis dataKey="x" tickFormatter={dateFormatter} />
          )
        }
      })()}
{/* 

      { resultSet.loadResponse.query.timeDimensions[0].granularity === 'hour' ? ( 
      <XAxis dataKey="x" tickFormatter={dateTimeFormatter} /> ) : 
      (<XAxis dataKey="x" tickFormatter={dateFormatter} />) } */}



      <YAxis />
      <CartesianGrid />
      {children}
      <Legend />
      <Tooltip cursor={false} />
    </ChartComponent>
  </ResponsiveContainer>
);

const colors = ["#9493DC", "#F7855E", "#BDC5CD", '#9A97A7', '#2A334A', "#6DAC4FFF", "#006B38FF", "#97BC62FF", "#2C5F2D", "#214a32", '#8cc63f', "#17703c", "#d5e4c0"];

const getPath = (x, y, width, height) => {
  return `M${x},${y + height}
          C${x + width / 3},${y + height} ${x + width / 2},${y + height / 3} ${x + width / 2}, ${y}
          C${x + width / 2},${y + height / 3} ${x + 2 * width / 3},${y + height} ${x + width}, ${y + height}
          Z`;
};

 
const TriangleBar = (props) => {
  const { fill, x, y, width, height } = props;

  return <path d={getPath(x, y, width, height)} stroke="none" fill={fill} />;
};

TriangleBar.propTypes = {
  fill: PropTypes.string,
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
};




const TypeToChartComponent = {
  line: ({ resultSet }) => (
    <CartesianChart resultSet={resultSet} ChartComponent={LineChart}>
      {resultSet.seriesNames().map((series, i) => (
        <Line
          key={series.key}
          stackId="a"
          dataKey={series.key}
          name={series.title}
          stroke={colors[i]}
        />
      ))}
    </CartesianChart>
  ),
  bar: ({ resultSet }) => (
    <CartesianChart resultSet={resultSet} ChartComponent={BarChart}>
      {/* {console.log('resultSet',resultSet)} */}
      {resultSet.seriesNames().map((series, i) => (
        // <Bar
        //   key={series.key}
        //   shape={<TriangleBar/>} 
        //   stackId="a"
        //   dataKey={series.key}
        //   stroke={colors[i]}
        //   name={series.title}
        //   fill={colors[i]}
        //   background={{ fill: '#eee' }}
        // /> 
         
        <Bar
          key={series.key}
          stackId="a"
          dataKey={series.key}
          name={series.title.replace(/^Work Order|^S Order/g, '')}
          fill={colors[i]}
        />
      ))}
    </CartesianChart>
  ),
  area: ({ resultSet }) => (
    <CartesianChart resultSet={resultSet} ChartComponent={AreaChart}>
      {resultSet.seriesNames().map((series, i) => (
        <Area
          key={series.key}
          stackId="a"
          dataKey={series.key}
          name={series.title}
          stroke={colors[i]}
          fill={colors[i]}
        />
      ))}
    </CartesianChart>
  ),
  pie: ({ resultSet }) => (
    <ResponsiveContainer width="100%" height={350}>
      {resultSet.seriesNames()[0] !== undefined ? (<PieChart>
        <Pie
          isAnimationActive={false}
          data={resultSet.chartPivot()}
          nameKey="x"
          dataKey={resultSet.seriesNames()[0] === undefined ? (0) : (resultSet.seriesNames()[0].key)}
          // label
          label={(entry)=> entry.name +' :  '+ entry.value }
        >
          {resultSet.chartPivot().map((e, index) => (
            <Cell key={index} fill={colors[index % colors.length]} />
          ))}
        </Pie>
        {/* <Legend /> */}
        <Tooltip />
      </PieChart>) : (<Row
        type="flex"
        justify="center"
        align="middle"
        style={{
          height: "100%"
        }}
      >
        <Col> <Statistic value={0} /> </Col> </Row>)}
    </ResponsiveContainer>
  ),
  number: ({ resultSet }) => (
    <Row type="flex" justify="center" align="middle" style={{ height: "100%" }}>
      <Col>
        {/* {console.log('resultSet', resultSet.loadResponse.annotation)} */}
        {/* // {this.state.showFilters && this.state.showHideOverAllFilters && ( */}
        {/* {resultSet.seriesNames().map(s => (
          // <Statistic value={(resultSet.totalRow()[s.key]).toFixed(2)} /> 
          <Statistic value={(resultSet.totalRow()[s.key])} />
         ))} */}
        {
          resultSet.seriesNames().map(s => {
            let chartValue = resultSet.totalRow()[s.key];
            let filterFormat = resultSet.loadResponse.annotation.measures;

            let formatSpec = ' ';
            if (filterFormat["SOrder.cancelled_percent"] || filterFormat["WorkOrder.late_percent"]) {
              formatSpec = "%";
            }
            if (filterFormat["WorkOrder.avg_work_order_duration_hours"] || filterFormat["WorkOrder.avg_work_order_lead_hours"]) {
              if (chartValue % 1 !== 0) { chartValue = Math.trunc(chartValue) }
              chartValue = convertToFormalHours(chartValue);
              return <Statistic value={chartValue + formatSpec} />
            } else {

              if (typeof chartValue === 'number') {
                if (chartValue % 1 === 0) {
                  return <Statistic value={chartValue + formatSpec} />
                } else {
                  return <Statistic value={chartValue.toFixed(2) + "" + formatSpec} />
                }
              } else { return undefined;
              }
            }

            // if (typeof chartValue === 'number') {
            //   if (chartValue % 1 === 0) {
            //     // int
            //     return <Statistic value={chartValue + formatSpec} />
            //   } else {
            //     return <Statistic value={chartValue.toFixed(2) + "" + formatSpec} />
            //   }
            // } else {
            // }



            // if (parseFloat(chartValue)) {
            //   // return <Statistic value={chartValue.toFixed(2)} />
            //   return <Statistic value={chartValue} />
            // }
            // else {
            //   return <Statistic value={chartValue} />
            // }


          })

        }
      </Col>
    </Row>
  ),
  table: ({ resultSet, pivotConfig }) => (
    <Table
      pagination={false}
      columns={resultSet.tableColumns(pivotConfig)}
      dataSource={resultSet.tablePivot(pivotConfig)}
    />
  )
};
const TypeToMemoChartComponent = Object.keys(TypeToChartComponent)
  .map(key => ({
    [key]: React.memo(TypeToChartComponent[key])
  }))
  .reduce((a, b) => ({ ...a, ...b }));

const renderChart = Component => ({ resultSet, error }) =>
  (resultSet && <Component resultSet={resultSet} />) ||
  (error && error.toString()) || <Spin />;

const ChartRenderer = ({ vizState }) => {
  const { query, chartType } = vizState;
  const component = TypeToMemoChartComponent[chartType];
  const renderProps = useCubeQuery(query);
  return component && renderChart(component)(renderProps);
};

ChartRenderer.propTypes = {
  vizState: PropTypes.object,
  cubejsApi: PropTypes.object
};
ChartRenderer.defaultProps = {
  vizState: {},
  cubejsApi: null
};
export default ChartRenderer;
